<template>
  <div class="container">
    <no-income-notification v-if="hasValidCreds && hasIncome === false" />
    <div v-else class="ri-large-headline ri-alte padding-horizontal-ml padding-top-ml padding-bottom-sm">
      {{ title }}
      <div class="padding-bottom-ml ri-large-body">{{ subtitle }}</div>
    </div>
    <new-credentials-list :background-color="backgroundColor" :allow-scroll="true"/>

    <div class="padding-ml">
      <riseup-button title="אפשר להמשיך"
                     :loading="isLoading"
                     :disabled="!(hasValidCreds && hasIncome === true)"
                     @click="nextPage"/>
    </div>

  </div>

</template>

<script>
import NewCredentialsList from '@/base-components/credentials/credentials-list/NewCredentialsList.vue';
import AddCredentialsFlow
  from '@/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/add-credentials-flow/AddCredentialsFlow';
import BaseUI from '@riseupil/base-ui';
import { mapGetters, mapActions, mapState } from 'vuex';
import Segment from '@/Segment';
import FlatTransactionsApi from '@/api/FlatTransactionsApi';
import NoIncomeNotification from './NoIncomeNotification.vue';

export default {
  name: 'OTSCredentialsConnection',
  components: { NewCredentialsList, RiseupButton: BaseUI.RiseupButton, NoIncomeNotification },
  props: {
    title: {
      type: String,
      required: false,
      default: 'החשבונות המחוברים לשירות',
    },
    subtitle: {
      type: String,
      required: false,
      default: 'הגישה לחשבון הבנק מאפשרת למערכת להציג לך את ההכנסות בצורה מדויקת',
    },
    backgroundColor: {
      type: String,
      required: false,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    Segment.trackUserGot('ConnectCredentialsEntered');
    await this.fetchCredentialsSettings();

    if (this.hasValidCreds) {
      // Preserve the last-known value on API failure. Initial value is null
      // (unknown) so a first-fetch failure keeps the button disabled and the
      // no-income notification hidden until we get a definitive answer.
      this.hasIncome = await FlatTransactionsApi.hasIncome().catch(() => this.hasIncome);
    }

    if (this.isVisible && !this.hasValidCreds) {
      this.openCreateCredentialsFlow();
    }
  },
  data() {
    return { isLoading: false, hasIncome: null };
  },
  computed: {
    ...mapGetters('credentialsNew', ['hasValidCreds']),
    ...mapState('websocket', ['socketMessage']),
  },
  watch: {
    async socketMessage() {
      // Keep the current value on API failure so we don't clobber a
      // known-good result (or a known-false one) with a fake positive.
      this.hasIncome = await FlatTransactionsApi.hasIncome().catch(() => this.hasIncome);
    },
    isVisible(newValue) {
      if (newValue && !this.hasValidCreds) {
        this.openCreateCredentialsFlow();
      }
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    ...mapActions('credentialsNew', ['fetchCredentialsSettings']),
    async nextPage() {
      this.isLoading = true;
      this.$emit('nextPage');
    },
    openCreateCredentialsFlow() {
      this.openModal({
        component: AddCredentialsFlow,
        popupAlignment: 'full-screen',
        props: {
          initWithSourceType: 'bank',
        },
        eventHandlers: {
          success: async () => {
            this.isLoading = true;
            await this.fetchCredentialsSettings();
            this.isLoading = false;
          },
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.container {
  display: flex;
  flex-direction: column;
}
</style>
